/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceStepResponseCallScriptDoc } from './sequenceStepResponseCallScriptDoc';
import type { SequenceStepResponseEmailBodyDoc } from './sequenceStepResponseEmailBodyDoc';
import type { SequenceStepResponseEmailSubjectDoc } from './sequenceStepResponseEmailSubjectDoc';
import type { SequenceStepResponseEmailSubjectMode } from './sequenceStepResponseEmailSubjectMode';
import type { SequenceStepResponseEmailThreadMode } from './sequenceStepResponseEmailThreadMode';
import type { SequenceStepResponseLinkedinMessageDoc } from './sequenceStepResponseLinkedinMessageDoc';
import type { SequenceStepResponsePriority } from './sequenceStepResponsePriority';
import type { SequenceStepResponseScheduleDelayType } from './sequenceStepResponseScheduleDelayType';
import type { SequenceStepResponseScheduleMode } from './sequenceStepResponseScheduleMode';
import type { SequenceStepResponseSmsBodyDoc } from './sequenceStepResponseSmsBodyDoc';
import type { SequenceStepResponseTaskNoteDoc } from './sequenceStepResponseTaskNoteDoc';
import type { SequenceStepResponseType } from './sequenceStepResponseType';

/**
 * Read-side shape for a single step row.
 */
export interface SequenceStepResponse {
  id: string;
  stable_id: string;
  step_set_id: string;
  step_index: number;
  type: SequenceStepResponseType;
  schedule_mode: SequenceStepResponseScheduleMode;
  schedule_delay_value?: number | null;
  schedule_delay_type?: SequenceStepResponseScheduleDelayType;
  schedule_at_time?: string | null;
  priority: SequenceStepResponsePriority;
  email_subject_mode?: SequenceStepResponseEmailSubjectMode;
  email_subject_doc?: SequenceStepResponseEmailSubjectDoc;
  email_body_doc?: SequenceStepResponseEmailBodyDoc;
  email_thread_mode?: SequenceStepResponseEmailThreadMode;
  email_cc?: string[];
  email_bcc?: string[];
  email_include_sender_signature?: boolean;
  email_include_unsubscribe_link?: boolean;
  linkedin_message_doc?: SequenceStepResponseLinkedinMessageDoc;
  linkedin_invitation_note?: string | null;
  linkedin_include_signature?: boolean;
  task_note_doc?: SequenceStepResponseTaskNoteDoc;
  call_script_doc?: SequenceStepResponseCallScriptDoc;
  sms_body_doc?: SequenceStepResponseSmsBodyDoc;
  created_at: string;
  updated_at: string;
  is_configured?: boolean;
}
